import { gql } from '@apollo/client';

export function modifyPerson() {
  return gql`
    mutation modifyPerson(
      $entityId: String!
      $personDetailsInputs: [Production_policyPersonInputs]
    ) {
      production {
        entities {
          policy {
            production {
              modifyPerson(
                entityId: $entityId
                policyPersonInputs: $personDetailsInputs
              )
            }
          }
        }
      }
    }
  `;
}

export function getZonesByCountry() {
  return gql`
    query getZonesByCountry($countryID: String!) {
      Insurance {
        lookups {
          zones(Insurance_Countries: $countryID) {
            Id
            Title
          }
        }
      }
    }
  `;
}
